export default __webpack_public_path__ + "static/media/filterIcon.54aee388.svg";